export class MoleculePanelOverviewHeaderMultiRestoreDomainDomainproductActionComponent {
    public templateUrl = require('./multi-restore-domain-domainproduct-action.html?external');
}
